"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spinner = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var CircularProgress_1 = tslib_1.__importDefault(require("@material-ui/core/CircularProgress/CircularProgress"));
var Spinner_style_1 = require("./Spinner.style");
var core_1 = require("@material-ui/core");
var TypographyColor_1 = require("../../../enums/TypographyColor");
var Spinner = function (_a) {
    var content = _a.content;
    var classes = (0, Spinner_style_1.useSpinnerStyles)();
    return (react_1.default.createElement("div", { className: classes.container },
        react_1.default.createElement(CircularProgress_1.default, { className: classes.loader }),
        content && (react_1.default.createElement(core_1.Typography, { color: TypographyColor_1.TypographyColor.primary, variant: "body2", className: classes.title }, content))));
};
exports.Spinner = Spinner;
